import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  index: number;
  className?: string;
  isMobile?: boolean;
  isTablet?: boolean;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon: Icon,
  title,
  description,
  index,
  className = '',
  isMobile = false,
  isTablet = false
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.6, 
        delay: index * 0.1,
        ease: [0.25, 0.46, 0.45, 0.94]
      }}
      viewport={{ once: true, margin: "-100px" }}
      whileHover={!isMobile ? { 
        y: -4,
        transition: { duration: 0.3, ease: "easeOut" }
      } : {}}
      className={`group relative bg-white rounded-none p-6 md:p-8 transition-all duration-500 border-b border-gray-100 hover:border-gray-200 ${className}`}
    >
      {/* Icône minimaliste */}
      <div className="mb-4">
        <Icon className="w-8 h-8 md:w-10 md:h-10 text-gray-900 group-hover:text-gray-700 transition-colors duration-300" strokeWidth={1} />
      </div>

      {/* Contenu épuré */}
      <div className="text-left">
        <h3 className="text-xl md:text-2xl font-light text-gray-900 mb-3 tracking-tight leading-tight">
          {title}
        </h3>
        <p className="text-base md:text-lg text-gray-500 leading-relaxed font-light">
          {description}
        </p>
      </div>
    </motion.div>
  );
};

export default FeatureCard;